/**
 * @fileOverview Ensures the current user's basic info is loaded before
 * rendering any children. Basic info consists of the user's name organisations
 * and the names of all their repositories.
 */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { loadBasicInfo } from './../../store/user/actions'

const mapStateToProps = (state, props) => ({
  // The !== false is required because on the first render pass this won't
  // even be set to `true` so we specifically want it to be false in order
  // to render children
  loading: state.loading['basic-info'] !== false,
})

const mapDispatchToProps = dispatch => ({
  loadBasicInfo: () => dispatch(loadBasicInfo()),
})

class BasicInfoHOC extends Component {

  componentWillMount = () => this.props.loadBasicInfo()

  render = () => {
    const { loading, loadingElement, children } = this.props
    if (loading) return loadingElement || null
    return children
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BasicInfoHOC)


// WEBPACK FOOTER //
// ./src/modules/BasicInfoHOC/BasicInfoHOC.js